import Vue from 'vue'
import VueDPlayer from '../assets/lib/vue-dplayer/dist/vue-dplayer.es.js'
import '../assets/lib/vue-dplayer/dist/vue-dplayer.css'
// 本地组件
import EndLine from './end-line.vue'
import DataEmpty from './data-empty.vue'
import ScrollFixed from './scroll-fixed.vue'
import FooterBtn from './footer-btn.vue'
import MySectionTitle from './section-title.vue'
import ZjSectionTitle from './zujuan/zj-section-title.vue'
import BreadCrumb from './breadcrumb.vue'
import TopBar from './top-bar.vue'
import Header from './header.vue'
import HeaderLogin from './header-login.vue'
import Footer from './footer.vue'
import GotoTop from './goto-top.vue'
import FooterVIP from './footer-vip.vue'
import TabTitle from './tab-title.vue'
import LoginDialog from './global-login-dialog.vue'
import GetVipDialog from './get-vip-dialog.vue'
import MsgBox from './message-box/message-box.vue'
import Identify from './identify.vue'
import QuestionItem from './quest/question-item.vue'
import QuickAside from './quick-aside.vue'
import BasketAside from './zujuan/basket-aside.vue'

// 以下是共用弹框
import GradePop from './pop/grade-pop.vue'
import CorrectPop from './pop/correct-pop.vue'
import PaperDownPop from './pop/paper-down-pop.vue'
import CollectPop from './pop/collect-pop.vue'
import BasketQuestionListPop from './pop/basket-question-list-pop.vue'

Vue.use(VueDPlayer, {
  name: 'tx-video-player'
})

// components
Vue.component('tx-end-line', EndLine)
Vue.component('tx-data-empty', DataEmpty)
Vue.component('tx-scroll-fixed', ScrollFixed)
Vue.component('tx-footer-btn', FooterBtn)
Vue.component('tx-section-title', MySectionTitle)
Vue.component('tx-zj-section-title', ZjSectionTitle)
Vue.component('tx-bread-crumb', BreadCrumb)
Vue.component('tx-top-bar', TopBar)
Vue.component('tx-header', Header)
Vue.component('tx-header-login', HeaderLogin)
Vue.component('tx-footer', Footer)
Vue.component('tx-goto-top', GotoTop)
Vue.component('tx-footer-vip', FooterVIP)
Vue.component('tx-tab-title', TabTitle)
Vue.component('tx-login-dialog', LoginDialog)
Vue.component('tx-get-vip-dialog', GetVipDialog)
Vue.component('tx-msg-box', MsgBox)
Vue.component('tx-identify', Identify)
Vue.component('tx-question-item', QuestionItem)
Vue.component('tx-quick-aside', QuickAside)
Vue.component('tx-basket-aside', BasketAside)
Vue.component('tx-basket-question-list', BasketQuestionListPop)

Vue.component('tx-grade-pop', GradePop)
Vue.component('tx-correct-pop', CorrectPop)
Vue.component('tx-paper-down-pop', PaperDownPop)
Vue.component('tx-collect-pop', CollectPop)
